<template>
    <div class="webhook_info">
        <b-overlay :show="is_load" rounded="sm">
            <button
                type="button"
                class="btn btn-lg waves-effect waves-themed w-100 mb-3"
                :class="cur_class"
                @click="make_action"
            >
                <span
                    class="fal mr-1"
                    :class="is_on ? 'fa-trash-alt' : 'fa-plus'"
                ></span>

                {{ __t(butt_title) }}
            </button>

            <div v-if="is_on && cur_hook" class="mt-4">

                <!-- Основная информация -->
                <div class="card border mb-4">
                    <div class="card-header bg-light">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="fw-bold">
                                    Webhook information
                                </div>

                                <small class="text-muted">
                                    Syrve / iiko webhook configuration
                                </small>
                            </div>

                            <span class="badge badge-success">
                                ACTIVE
                            </span>
                        </div>
                    </div>

                    <div class="card-body">

                        <div class="hook-row">
                            <div class="hook-label">
                                Correlation ID
                            </div>

                            <div class="hook-value hook-mono">
                                {{ cur_hook.correlationId || '—' }}
                            </div>
                        </div>

                        <div class="hook-row">
                            <div class="hook-label">
                                API login
                            </div>

                            <div class="hook-value">
                                {{ cur_hook.apiLoginName || '—' }}
                            </div>
                        </div>

                        <div class="hook-row">
                            <div class="hook-label">
                                Webhook URL
                            </div>

                            <div class="hook-value">
                                <code class="hook-url">
                                    {{ cur_hook.webHooksUri || '—' }}
                                </code>

                                <button
                                    v-if="cur_hook.webHooksUri"
                                    type="button"
                                    class="btn btn-xs btn-outline-secondary ml-2"
                                    @click="copy(cur_hook.webHooksUri)"
                                >
                                    <span class="fal fa-copy"></span>
                                </button>
                            </div>
                        </div>

                        <div class="hook-row">
                            <div class="hook-label">
                                Auth token
                            </div>

                            <div class="hook-value d-flex align-items-center">
                                <code class="hook-token">
                                    {{
                                        show_token
                                            ? cur_hook.authToken
                                            : maskToken(cur_hook.authToken)
                                    }}
                                </code>

                                <button
                                    v-if="cur_hook.authToken"
                                    type="button"
                                    class="btn btn-xs btn-outline-secondary ml-2"
                                    @click="show_token = !show_token"
                                >
                                    <span
                                        class="fal"
                                        :class="show_token ? 'fa-eye-slash' : 'fa-eye'"
                                    ></span>
                                </button>

                                <button
                                    v-if="cur_hook.authToken"
                                    type="button"
                                    class="btn btn-xs btn-outline-secondary ml-1"
                                    @click="copy(cur_hook.authToken)"
                                >
                                    <span class="fal fa-copy"></span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Filters -->
                <div
                    v-if="cur_hook.webHooksFilter"
                    class="card border"
                >
                    <div class="card-header bg-light">
                        <div class="fw-bold">
                            Event subscriptions
                        </div>
                    </div>

                    <div class="card-body p-0">

                        <div
                            v-for="filter in hook_filters"
                            :key="filter.key"
                            class="filter-block"
                        >
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <div class="filter-title">
                                    {{ filter.title }}
                                </div>

                                <span
                                    class="badge"
                                    :class="filter.enabled ? 'badge-success' : 'badge-secondary'"
                                >
                                    {{ filter.enabled ? 'ENABLED' : 'DISABLED' }}
                                </span>
                            </div>

                            <template v-if="filter.statuses.length">
                                <div class="text-muted fs-sm mb-2">
                                    Statuses
                                </div>

                                <div class="d-flex flex-wrap">
                                    <span
                                        v-for="status in filter.statuses"
                                        :key="status"
                                        class="status-badge"
                                    >
                                        {{ status }}
                                    </span>
                                </div>
                            </template>

                            <div
                                v-if="filter.hasErrors !== null"
                                class="mt-3"
                            >
                                <span
                                    class="badge"
                                    :class="filter.hasErrors ? 'badge-warning' : 'badge-secondary'"
                                >
                                    Errors:
                                    {{ filter.hasErrors ? 'YES' : 'NO' }}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- JSON debug, если нужен -->
                <details class="mt-4">
                    <summary class="text-muted cursor-pointer">
                        Raw webhook response
                    </summary>

                    <pre class="raw-json mt-3">{{ pretty_hook }}</pre>
                </details>

            </div>
        </b-overlay>
    </div>
</template>

<script>
export default {
    name: "iiko_webhook",

    props: {
        org: {
            type: Object
        }
    },

    data() {
        return {
            is_load: false,
            cur_hook: null,
            show_token: false,
        }
    },

    mounted() {
        this.load_hook();
    },

    methods: {

        async make_action() {
            this.is_load = true;

            await pos_api
                .patch('/syrve/organizations/' + parseInt(this.org.id) + "/hook")
                .then(({data}) => {
                    this.is_load = false;

                    if (data.status === "operation_success") {
                        EventBus.$emit("reload_org");
                        this.load_hook();
                    }
                })
                .catch(({response}) => {
                    this.is_load = false;

                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position: "b-toaster-top-left",
                    });
                });
        },

        async load_hook() {
            this.cur_hook = null;
            this.is_load = true;

            await pos_api
                .get('/syrve/organizations/' + parseInt(this.org.id) + "/hook")
                .then(({data}) => {
                    if (data.status === "operation_success") {
                        this.cur_hook = data.data;
                    }
                })
                .catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position: "b-toaster-top-left",
                    });
                })
                .finally(() => {
                    this.is_load = false;
                });
        },

        maskToken(token) {
            if (!token) {
                return '—';
            }

            if (token.length <= 12) {
                return '••••••••';
            }

            return token.substring(0, 6)
                + '••••••••••••'
                + token.substring(token.length - 6);
        },

        async copy(value) {
            if (!value) {
                return;
            }

            try {
                await navigator.clipboard.writeText(value);

                EventBus.$emit('show_toast', {
                    err: 'Copied to clipboard',
                    type: "success",
                    title: 'Webhook',
                    position: "b-toaster-top-left",
                });
            } catch (e) {
                console.error(e);
            }
        },

        prettifyName(name) {
            if (!name) {
                return '';
            }

            return name
                .replace(/Filter$/, '')
                .replace(/([A-Z])/g, ' $1')
                .trim()
                .replace(/^./, str => str.toUpperCase());
        },
    },

    computed: {

        is_on() {
            if (this.org.hasOwnProperty("is_hook_added")) {
                return this.org.is_hook_added;
            }

            return false;
        },

        cur_class() {
            return this.is_on
                ? "btn-danger"
                : "btn-success";
        },

        butt_title() {
            return this.is_on
                ? "REMOVE_HOOK"
                : "ADD_HOOK";
        },

        pretty_hook() {
            if (!this.cur_hook) {
                return '';
            }

            return JSON.stringify(this.cur_hook, null, 4);
        },

        hook_filters() {
            if (!this.cur_hook?.webHooksFilter) {
                return [];
            }

            return Object.entries(this.cur_hook.webHooksFilter)
                .map(([key, value]) => {

                    value = value || {};

                    const statuses =
                        value.orderStatuses
                        || value.itemStatuses
                        || [];

                    return {
                        key,
                        title: this.prettifyName(key),

                        enabled:
                            value.updates === true
                            || statuses.length > 0,

                        statuses,

                        hasErrors:
                            typeof value.errors === 'boolean'
                                ? value.errors
                                : null,
                    };
                });
        },
    }
}
</script>

<style scoped>
.webhook_info {
    width: 100%;
}

.card {
    border-radius: 6px;
    overflow: hidden;
}

.card-header {
    padding: 14px 18px;
}

.card-body {
    padding: 18px;
}

.hook-row {
    display: flex;
    align-items: flex-start;
    padding: 12px 0;
    border-bottom: 1px solid #edf0f2;
}

.hook-row:last-child {
    border-bottom: 0;
}

.hook-label {
    flex: 0 0 160px;
    width: 160px;
    font-size: 13px;
    font-weight: 600;
    color: #6c757d;
}

.hook-value {
    flex: 1;
    min-width: 0;
    color: #333;
    word-break: break-word;
}

.hook-mono,
.hook-url,
.hook-token {
    font-family: Consolas, Monaco, monospace;
    font-size: 13px;
}

.hook-url {
    white-space: normal;
    word-break: break-all;
}

.filter-block {
    padding: 16px 18px;
    border-bottom: 1px solid #edf0f2;
}

.filter-block:last-child {
    border-bottom: none;
}

.filter-title {
    font-weight: 600;
    color: #343a40;
}

.status-badge {
    display: inline-flex;
    align-items: center;

    padding: 5px 9px;
    margin: 0 6px 6px 0;

    background: #f1f3f5;
    border: 1px solid #dee2e6;
    border-radius: 4px;

    color: #495057;
    font-size: 12px;
    font-family: Consolas, Monaco, monospace;
}

.raw-json {
    padding: 15px;
    background: #212529;
    color: #e9ecef;

    border-radius: 5px;

    font-size: 12px;
    line-height: 1.5;

    overflow-x: auto;
    white-space: pre-wrap;
    word-break: break-word;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
